import React, { useContext } from "react"

import { gql, useQuery } from "urql"

import TutorContext from "~Tutor/TutorContext"
import TutorSubjectsTable from "~Tutor/components/TutorSubjects/Table"
import { H2, WithLoadingIndicator } from "~tailwindui/Basics"

const TutorSubjects = () => {
  const { viewer } = useContext(TutorContext)
  const tutorId = viewer.id
  const [result, refetchQuery] = useQuery({
    query,
    variables: { tutorId },
  })

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { viewer } }) => (
        <div className="mx-auto w-full sm:w-max">
          <H2>My Subjects</H2>

          <TutorSubjectsTable
            tiers={viewer.tiers}
            refetchQuery={refetchQuery}
          />
        </div>
      )}
    </WithLoadingIndicator>
  )
}

const query = gql`
  query TutorSubjects($tutorId: ID!) {
    viewer {
      id
      tiers {
        id
        gradeRange
        subjectBuckets(tutorId: $tutorId) {
          id
          name
          approvalState(tutorId: $tutorId)
        }
      }
    }
  }
`

export default TutorSubjects
